<template>
    <div>
        <b-container class="mt-5 mb-5">
            <h1 class="fs-4 font-weight-bold mb-4">Alle tickets</h1>

            <b-alert variant="info" show>
                <font-awesome-icon icon="fa-solid fa-info-circle" class="mr-1" />
                Hier vind je alle tickets die zijn besteld tijdens een van je evenementen terug.
            </b-alert>

            <b-card no-body>

                <b-card-header>
                    <div class="float-sm-left">
                        Aantal gevonden: {{ totalRows }}
                    </div>
                    <div class="float-sm-right">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <font-awesome-icon icon='fa-solid fa-search' />
                            </b-input-group-prepend>
                            <vue-bootstrap-autocomplete
                                :data="eventResults"
                                v-model="searchQuery"
                                :serializer="event => event.name"
                                placeholder="Zoek een event..."
                                @input="searchEvents"
                                @hit="onEventSelected"
                            />
                        </b-input-group>
                    </div>
                </b-card-header>

                <!-- BODY -->
                <b-card-body>

                    <div v-if="customers.length <= 0" class="text-center text-muted mt-4 mb-4">
                        <font-awesome-icon icon="fa-solid fa-users" class="mb-2" size="2x" />
                        <div class="text-dark fs-5">Geen klanten gevonden</div>
                    </div>

                    <template v-else>
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Voornaam</th>
                                    <th>Achternaam</th>
                                    <th>E-mail</th>
                                    <th>Evenement</th>
                                    <th>Datum</th>
                                    <th>Ingeschreven op</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="customer in customers" :key="customer.id">
                                    <td>{{ customer.firstname }}</td>
                                    <td>{{ customer.lastname }}</td>
                                    <td>{{ customer.email }}</td>
                                    <td>{{ customer.event.name }}</td>
                                    <td>{{ customer.event.date.start_at | formatDateTime }}</td>
                                    <td>{{ customer.created_at.date | formatDateTime }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>

                </b-card-body>
                <b-card-footer>
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            Pagina {{ currentPage }} van {{ totalPages }}
                        </div>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @change="onPageChange"
                        />

                    </div>
                </b-card-footer>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete';

export default {
    metaInfo: {
        title: 'Alle tickets',
    },
    components: {
      VueBootstrapAutocomplete,
    },
    data() {
        return {
            customers: [],
            eventResults: [],
            searchQuery: '',
            searchSelected: null,
            currentPage: 1,
            perPage: 15,
            totalRows: 0
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalRows / this.perPage);
        },
        searchOptions() {
            let options = [
                { text: 'Alle events', value: null }
            ];
            this.events.forEach(event => {
                options.push({
                    text: event.name,
                    value: event.id
                });
            });
            return options;
        }
    },
    methods: {
        onEventSelected(event) {
            this.searchSelected = event.id;
            this.currentPage = 1;
            this.getTickets(1);
        },
        async getTickets(page = 1) {
            try {
                let url = `https://api.tixgo.nl/customers/tickets?page=${page}&per_page=${this.perPage}`;

                if (this.searchSelected) {
                    url += `&event=${this.searchSelected}`;
                }

                const response = await this.$axios.get(url);

                // Verwacht Laravel pagination structuur
                this.customers = response.data.data;
                this.totalRows = response.data.total;
                this.currentPage = response.data.current_page;

            } catch (error) {
                console.log(error);
            }
        },
        async searchEvents(query) {

            if (!query || query.length === 0) {
                this.searchSelected = null;
                this.eventResults = [];
                this.currentPage = 1;
                this.getTickets(1);
                return;
            }

            if (query.length < 2) {
                this.eventResults = [];
                return;
            }

            try {
                const response = await this.$axios.get(
                    `https://api.tixgo.nl/events?search=${query}`
                );

                this.eventResults = response.data.data;

            } catch (error) {
                console.log(error);
            }
        },
        onFilterChange() {
            this.currentPage = 1;
            this.getTickets(1);
        },
        onPageChange(page) {
            this.getTickets(page);
        }
    },
    created() {
        this.getTickets();
    }
}
</script>